import React from "react";
import { Link } from "react-router-dom";

import MetricCard from "./MetricCard";
import styles from "./index.module.scss";
import { ICategoryData } from "shared/models/AllOrgMetricsModel";
import { subtext } from "src/shared/config";

interface IAllOrgMetricsProps {
  tiles: ICategoryData[];
  label: string;
  showDetails: (id: any, name: string) => void;
  failure: boolean;
  selectedTab: string;
}

const MetricGroups: React.FC<IAllOrgMetricsProps> = ({ tiles, label, showDetails, failure, selectedTab }) => {
  const safeTiles = Array.isArray(tiles) ? tiles : [];
  return (
    <div className={styles["metric-group"]}>
      <div className={styles["metric-group-header"]}>
        <div className={styles["metric-group-title"]}>{label}</div>
        <div className={styles["see-more"]}>
          <Link to={{ pathname: `/category/${label}` }}>VIEW ALL</Link>
        </div>
      </div>
      <div className={styles["metric-group-content"]}>
        {safeTiles.map((eachTile) => (
          <div className={styles["metric"]} key={eachTile.id}>
            <MetricCard
              bigNumber={eachTile.bigNumber}
              vCompare={eachTile.vCompare}
              progress={eachTile.progress}
              isPositive={eachTile.isPositive}
              header={eachTile.label}
              showDetails={showDetails}
              id={eachTile.id}
              successful={eachTile.successful === true}
              hasChart={eachTile.hasChart}
              failure={failure}
              isAnomalous={eachTile.isAnomalous}
              isStaleMetric={eachTile.isStaleMetric}
            />
          </div>
        ))}
      </div>
      {safeTiles.length > 0 && <div className={styles["metric-group-footer"]}>{subtext[selectedTab] || ""}</div>}
    </div>
  );
};

export default MetricGroups;
